<template>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="text-center">

        <div class="mt-3 text-center">
            <img v-bind:src="'../imgs/aruvaa_logo.png'" class="block" style="margin:auto; display:block; width:100px; height:40px">
        </div> 

        <div class="text-center mt-2">
          <h3 class="text-center">Welcome Back</h3>
        </div>
    <div class="container-fluid">

        <form class="form-style text-center">
            <input class="mt-2 border rounded-lg border-gray-300 w-full" id="email" type="email" placeholder="Email" maxlength="50" required> <br>
            <input class="mt-2 border rounded-lg border-gray-300 w-full" id="password" type="password" placeholder="Password" maxlength="50" required> <br>

            <jet-button type="button" id="signinbutton" v-on:click="startAuth()"
                    class="rounded-lg w-full bg-indigo-600 text-white mt-4 pt-2 pb-2 text-lg">Sign in
            </jet-button>
            
        </form>
        <br><br><br>
            
        <div class="privacy-style text-lg ml-4">
          <span>
            Don't have  account? 
              <a href="{{ url('/register') }}">
                <span class="ml-2">Register here</span>
              </a> 
            </span>
        </div>

        <div class="privacy-style absolute inset-x-0 bottom-0 text-lg ml-4">
          <span class=""> 
              <a href="{{ url('/register') }}" class="no-decoration text-dark">
                <span class="ml-2 text-sm">Terms</span>
              </a> 
            </span> |<span> 
              <a href="{{ url('/register') }}" class=" text-dark no-decoration">
                <span class="ml-2 text-sm">Privacy Policy</span>
              </a> 
            </span>
        </div>
    </div>

        
      </div>
    </div>    
</template>
<style>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .img-company-logo {
        width: 50px;
        height: 50px;
    }

    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }

    </style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue';
import JetButton from "@/Jetstream/Button.vue";



export default {
  props: ["sessions"],

  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
    JetButton,
  },
  data() {
    return {
      title: "Login",
      username: null,
      password: null,

    };
  },
  methods: {
    startAuth(){
      window.location.href = "/app/paytime/punchin";      
    },
    getOrganisation() {
      axios.get("tenants/list").then((response) => {
      
      });
    },
  },
  mounted() {
    this.getOrganisation();
  },
};
</script>
